import { useEffect, useState } from "react";
import logo from "../../images/logos/logo.png";

const FADE_DURATION = 3000;

export default function Loading() {
    const [visible, setVisible] = useState(true);
    const [shouldRender, setShouldRender] = useState(true);

    useEffect(() => {
        const hide = () => setVisible(false);

        if (document.readyState === "complete") {
            hide();
        } else {
            window.addEventListener("load", hide, { once: true });
        }

        const fallback = setTimeout(hide, 300);

        return () => {
            clearTimeout(fallback);
            window.removeEventListener("load", hide);
        };
    }, []);

    useEffect(() => {
        if (!visible) {
            const t = setTimeout(() => setShouldRender(false), FADE_DURATION);
            return () => clearTimeout(t);
        }
    }, [visible]);

    if (!shouldRender) return null;

    return (
        <div className={`loading-screen ${visible ? "" : "hidden"}`}>
            <div className="loading-logo">
                <img src={logo} alt="Loading..." />
            </div>
        </div>
    );
}
